export default "<dtp-fixed-header label=\"Dashboard\">\n</dtp-fixed-header>"